<script>
	import { getTealiumID, registerPageComplete } from "../../tealium";
	import model from "../../stores/modelStore";
	import { projectSettings, referralTypes } from "../../config";
	import registrationTypes from "../../config/registrationTypes";
	import Person from "../../models/Person";
	import ClaimantDetails from "../../models/ClaimantDetails";
	import { isValid } from "../../validation";

	import Contact from "../../components/Contact.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import Claimant from "../../components/Claimant.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	export let pageName = null;
	export let disabled = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let required = true;
	let buttons = null;

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		$model.tealiumId = getTealiumID();
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(response);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const handleRegistrationTypeChange = () => {
		$model.claimants = [new Person()];
		$model.claimantDetails = new ClaimantDetails();
	};

	const initialise = () => {};

	initialise();
</script>

<PageSection>
	<Form {disabled} id="form-personal-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">
					{@html projectSettings.classActionName}
				</h4>
				<h1 class="text-center">Please provide your details</h1>
				<p>
					If you are unable to complete any part of this section of the form, we are here to assist you.
					Please contact us on <ClassActionPhoneNumber /> or via email to <ClassActionEmailAddress />.
				</p>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<Contact
				bind:firstName={$model.contact.firstName}
				bind:surname={$model.contact.surname}
				bind:emailAddress={$model.contact.emailAddress}
				bind:phoneNumber={$model.contact.phoneNumber}
				bind:address={$model.contact.address}
				bind:dateOfBirth={$model.contact.dateOfBirth}
				idPrefix="contact"
				{required}
				{disabled}
			/>

			<FormRow>
				<FormColumn>
					<Select
						{required}
						{disabled}
						label="Who are you registering for?"
						id="regType"
						bind:value={$model.registrationType}
						optionList={registrationTypes.options}
						textProperty="name"
						valueProperty="value"
						on:change={handleRegistrationTypeChange}
					/>
				</FormColumn>
			</FormRow>
		</div>

		{#if $model.registrationType && $model.registrationType != registrationTypes.types.Myself.value}
			<div class="confirmation-box-shadow">
				<div class="claimant-details">
					<Claimant
						{disabled}
						registrationType={$model.registrationType}
						bind:claimantDetails={$model.claimantDetails}
						bind:claimants={$model.claimants}
						contactFirstName={$model.contact.firstName}
						contactSurname={$model.contact.surname}
					/>
				</div>
			</div>
		{/if}

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<Select
						{required}
						{disabled}
						label="Where did you hear about our firm?"
						id="whereDidYouHear"
						bind:value={$model.whereDidYouHear}
						optionList={referralTypes}
						textProperty="name"
						valueProperty="name"
					/>
				</FormColumn>
			</FormRow>
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	.claimant-details {
		margin-bottom: 20px;
	}
</style>
